import { compose } from '@fluentui/react-bindings';
import { Input } from '../Input/Input';
import { _FormFieldBase } from './utils/formFieldBase';
import { commonPropTypes } from '../../utils';
export var formInputClassName = 'ui-form__input';
/**
 * An FormInput renders a Input wrapped by FormField.
 */

export var FormInput = /*#__PURE__*/function () {
  var FormInput = compose(_FormFieldBase, {
    className: formInputClassName,
    displayName: 'FormInput',
    handledProps: ['label', 'labelPosition', 'required'],
    overrideStyles: true,
    slots: {
      control: Input
    },
    slotProps: function slotProps(_ref) {
      var errorMessage = _ref.errorMessage,
          required = _ref.required,
          labelPosition = _ref.labelPosition;
      return {
        label: {
          required: required
        },
        control: {
          error: !!errorMessage,
          labelPosition: labelPosition,
          required: required
        },
        message: {
          error: !!errorMessage
        }
      };
    }
  });
  FormInput.propTypes = commonPropTypes.createCommon({
    children: false,
    content: false
  });
  return FormInput;
}();